import Vue from 'vue';

const state = {
    jwt: "",
    apiUrl: "",
    user: "",
    type: "",
    sede: "",
    season: "",
};

const mutations = {
    'SET_API_URL'(state, apiUrl) {
        state.apiUrl = apiUrl;
    },
    'SET_JWT'(state, jwt) {
        state.jwt = jwt;
    },
    'SET_USER'(state, user) {
        state.user = user;
    },
    'SET_TYPE'(state, type) {
        state.type = type;
    },
    'SET_SEDE'(state, sede) {
        state.sede = sede;
    },
    'SET_SEASON'(state, season) {
        state.season = season;
    }
};

const actions = {
    setJWT: ({commit}, jwt) => {
        commit('SET_JWT', jwt);
    },
    setApiUrl: ({commit}, apiUrl) => {
        commit('SET_API_URL', apiUrl);
    },
    setUser: ({commit}, user) => {
        commit('SET_USER', user);
    },
    setType: ({commit}, type) => {
        commit('SET_TYPE', type);
    },
    setSede: ({commit}, sede) => {
        commit('SET_SEDE', sede);
    },
    setSeason: ({commit}, season) => {
        commit('SET_SEASON', season);
    }
};

const getters = {
    jwt: state => {
        return state.jwt;
    },
    apiUrl: state => {
        return state.apiUrl;
    },
    user: state => {
        return state.user;
    },
    type: state => {
        return state.type;
    },
    sede: state => {
        return state.sede;
    },
    season: state => {
        return state.season;
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}
